import { http } from './http'
import { CreatClient } from '../../common/models/clients'
import { OrderPaymentStatus } from '../../common/models/orders'

export type Pagination<T> = {
  content: T[]
  totalElements: number
  totalPages: number
  size: number
  pageNumber: number
  empty: boolean
}

export type LocaleObject = { [key: string]: string }

export interface IClient {
  id: string
  phoneNumber: string
  email: string
  details: {
    validatedEmail: boolean
    billingAddress: boolean
    shippingAddress: boolean
  }
  referralCode: string
  newPassword: string
  lastActivity: number
  createdDate: number
  ordersSize: number
  runa: number
  firstName?: string
  lastName?: string
  location?: string
  scanTicketsPermission: boolean
}

export interface IClientPayload {
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  newPassword?: string | null
  scanTicketsPermission: boolean
}

export interface IClientOrders {
  id: string
  festivalName: string
  ticketNames: string[]
  buyer: {
    name: string
    phoneNumber: string
    email: string
  }
  receivers: [
    {
      name: string
      phoneNumber: string
      email: string
    },
  ]
  price: {
    value: number
    currency: string
    runa: number
  }
  addons: string[]
  discountVoucher: string
  purchaseDate: number
  paymentStatus: OrderPaymentStatus
  payFullPrice: boolean
  payInstallments: boolean
}

export interface IBillingAddress {
  address: string
  city: string
  postCode: string
  country: string
  nationality: string
  id?: string
}

export interface IShippingAddress {
  useDataFromBillingAddress: boolean
  address: string
  country: string
  city: string
  postCode: string
  id?: string
}

export type PaginationParams = {
  page?: number
  size?: number
  sortBy?: string
  sortDirection?: 'ASC' | 'DESC'
  email?: string | null
  phone?: string | null
}

export const clients = (params?: PaginationParams) =>
  http.get<Pagination<IClient>>('/operations/clients', {
    params,
  })

export const clientsOrders = (id: string, params?: PaginationParams) =>
  http.get<Pagination<IClientOrders>>(`/operations/clients/${id}/orders`, {
    params,
  })

export const clientsDetails = (id: string) =>
  http.get<IClient>(`/operations/clients/${id}`)

export const updateClientsDetails = (id: string, data: IClientPayload) =>
  http.put(`/operations/clients/${id}`, data)

export const clientsShippingAddress = (id: string) =>
  http.get<IShippingAddress>(`/operations/clients/${id}/shipping-address`)

export const updateClientsShippingAddress = (
  id: string,
  data: IShippingAddress,
) =>
  http.put<IShippingAddress>(`/operations/clients/${id}/shipping-address`, data)

export const clientsBillingAddress = (id: string) =>
  http.get<IBillingAddress>(`/operations/clients/${id}/billing-address`)

export const updateClientsBillingAddress = (
  id: string,
  data: IBillingAddress,
) =>
  http.put<IBillingAddress>(`/operations/clients/${id}/billing-address`, data)

export const clientsConfirmEmail = (id: string, data: { email: string }) =>
  http.post(`/operations/clients/${id}/confirm-email`, data)

export const createClients = (data: CreatClient) =>
  http.post(`/operations/clients`, data)

export const resetRedeemCounter = (clientId: string) =>
  http.put(`/operations/clients/${clientId}/reset-redeem-counter`)
